export const CloudFunctions = {
  AddUser:"addUser",
  AddEmployee: "addEmployee",
  AdjustTimeClockEntry: "adjustTimeClockEntry",
  ClockIn: "clockIn",
  ClockOut: "clockOut",
  CreateConnectedStripeAccountCustomer:"createConnectedStripeAccountCustomer",
  CreateCustomerPortalSession:"createCustomerPortalSession",
  CreateInvoiceForStripeCustomers:"createInvoiceForStripeCustomers",
  CreateOrganization:"createOrganization",
  CreateStripeAccountLink:"createStripeAccountLink",
  CreateStripeProduct:"createStripeProduct",
  ExchangeGoogleToken:"exchangeGoogleToken",
  GenerateDocument:"generateDocument",
  GetStripeProduct:"getStripeProduct",
  ListStripeInvoicesForCustomers:"listStripeInvoicesForCustomer",
  ReceiveOrder:"receiveOrder",
  SendInvoiceToCustomer:"sendInvoiceToCustomer",
  UpdateStripeBranding:"updateStripeBranding",
  UpdateProductImage:"updateProductImage",
  UpdateStripeProduct:"updateStripeProduct",
  DeleteStripeProduct:"deleteStripeProduct",
  UpdateInvoiceSettings: 'updateInvoiceSettings',
  VoidStripeInvoice: "voidStripeInvoice",
  RefreshGoogleToken:"refreshGoogleToken",
  RefundStripeInvoice: "refundStripeInvoice",
  RefreshProfilePicture: "refreshProfilePicture",
  GenerateInvoicePreview: 'generateInvoicePreview',
  ConfigureStripeTaxSettings: 'configureStripeTaxSettings',
}